import Layout from "../layouts/layout";
import Schedule from "../sections/_constraints/Schedule";
import styles from "../styles/_screens/constraints.module.scss";

const Constraints = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h1>Create a Constraint</h1>

          {/* constraint types */}
          <div className={styles.field}>
            <h3>Constraint Type</h3>
            <select name="constraintType">
              <option value="" selected disabled>
                Choose one of the options
              </option>
              <option value="">
                Main attraction - change of operating hours
              </option>
              <option value="">
                Secondary attraction - permanent - change of operating hours
              </option>
            </select>
          </div>

          {/* select an attraction */}
          <div className={styles.field}>
            <h3>Select an attraction</h3>
            <select name="attraction">
              <option value="" selected disabled>
                Choose one of the options
              </option>
              <option value="">
                Entrance fees to the Ben-Gurion barracks site
              </option>
              <option value="">
                Interactive presentation: "The Law of the People"
              </option>
            </select>
          </div>

          {/* working hours */}
          <Schedule />

          <button className={styles.submitBtn}>Add a constraint</button>
        </div>
      </div>
    </Layout>
  );
};

export default Constraints;
